// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__whitn","menu__list":"styles_menu__list__yEOjX","menu__footer":"styles_menu__footer__2QXCD"};